<template>
  <div class="home">
    <div class="container">

      <div><a class="weatherwidget-io" href="https://forecast7.com/en/29d03n95d43/lake-jackson/?unit=us" data-label_1="LAKE JACKSON" data-label_2="WEATHER" data-theme="original" >LAKE JACKSON WEATHER</a></div>

      <div id="article-list" class="d-flex flex-column">
        <div class="article d-flex">
          <router-link class="article-image" to="/articles/bucees-new-colorado-proposal">
            <img alt="Bucees HQ" src="../assets/articles/bucees-new-colorado-proposal/bucees-office.jpg">
          </router-link>
          <div class="article-description">
            <div class="article-title">
              <router-link to="/articles/bucees-new-colorado-proposal">
                Buc-ees Submits New Proposal for Second Colorado Store at Different Location
              </router-link>
            </div>
            <div>March 30, 2025</div>
            <div>Landjaeger est in nostrud laboris shank short loin nisi frankfurter qui reprehenderit venison. Beef ribs tail fatback, chicken consectetur ribeye beef. Ut porchetta pork belly non bacon sed pancetta exercitation aute chuck chislic excepteur ut. Strip steak exercitation nisi, aliquip t-bone corned beef ut. Pork eiusmod cupim, pig</div>
          </div>
        </div>

        <div class="article d-flex">
          <router-link class="article-image" to="/articles/dont-colorado-my-texas">
            <img alt="Bucees HQ" src="../assets/articles/dont-colorado-my-texas/denver.jpg">
          </router-link>
          <div class="article-description">
            <div class="article-title">
              <router-link to="/articles/bucees-new-colorado-proposal">
                Keep Texas, Texas: Don’t Colorado My Texas
              </router-link>
            </div>
            <div>March 26, 2025</div>
            <div>Drumstick venison flank short ribs t-bone pancetta tongue pork chop pastrami ribeye doner shoulder ham. Pig pastrami t-bone pork, ham kielbasa boudin pancetta prosciutto venison jowl cupim turkey. Bresaola pork chop sirloin, jowl tongue swine short loin andouille doner boudin meatball cow salami. Ribeye chuck meatloaf, tongue ham cow jowl alcatra picanha pork loin filet mignon. Chicken ham alcatra turducken doner.</div>
          </div>
        </div>

        <div class="article d-flex">
          <router-link class="article-image" to="/articles/subaru-campaign">
            <img alt="Bucees HQ" src="../assets/articles/subaru-campaign/2025_subaru_crosstrek.jpg">
          </router-link>
          <div class="article-description">
            <div class="article-title">
              <router-link to="/articles/bucees-new-colorado-proposal">
                Subaru Rolls Out Campaign to Shake Off 'Slow Driver' Stereotype
              </router-link>
            </div>
            <div>March 18, 2025</div>
            <div>Alcatra burgdoggen shoulder chicken. Buffalo drumstick ham sausage strip steak tongue jowl bresaola ribeye. Tail kevin meatball boudin, capicola andouille venison picanha tenderloin t-bone ham hock. Beef ribs shank brisket meatloaf alcatra pig strip steak. Bresaola ribeye short loin picanha turkey kielbasa.</div>
          </div>
        </div>

        <div class="article d-flex">
          <router-link class="article-image" to="/articles/turkey-psycology">
            <img alt="Bucees HQ" src="../assets/articles/turkey-psycology/turkeys.jpg">
          </router-link>
          <div class="article-description">
            <div class="article-title">
              <router-link to="/articles/bucees-new-colorado-proposal">
                The Psychology of Turkeys: Why Honking Your Horn Won’t Budge Them
              </router-link>
            </div>
            <div>March 07, 2025</div>
            <div>Pastrami flank jowl jerky. Pork pork chop chuck doner, brisket biltong ground round picanha pork belly ham hock. Alcatra strip steak prosciutto, pork pork belly buffalo meatball sirloin chuck meatloaf jowl. Pork short ribs kevin cow prosciutto pastrami sausage biltong ground round ribeye boudin salami t-bone.</div>
          </div>
        </div>

        <div class="article d-flex">
          <router-link class="article-image" to="/articles/prime-vans">
            <img alt="Bucees HQ" src="../assets/articles/prime-vans/primevan.jpg">
          </router-link>
          <div class="article-description">
            <div class="article-title">
              <router-link to="/articles/prime-vans">
                Overrun by Amazon Vans? Here’s How to Cut Down the Traffic
              </router-link>
            </div>
            <div>March 02, 2025</div>
            <div>Pork belly ham hock filet mignon brisket pastrami spare ribs burgdoggen frankfurter pancetta porchetta. Venison chislic t-bone meatloaf jerky pork loin. Sausage pig jerky brisket flank swine kevin porchetta beef ribs. Landjaeger tail burgdoggen, swine ham hock pastrami biltong andouille doner frankfurter sirloin.</div>
          </div>
        </div>



      </div>








    </div>
  </div>
</template>

<script>
!function(d,s,id){var js,fjs=d.getElementsByTagName(s)[0];if(!d.getElementById(id)){js=d.createElement(s);js.id=id;js.src='https://weatherwidget.io/js/widget.min.js';fjs.parentNode.insertBefore(js,fjs);}}(document,'script','weatherwidget-io-js');
</script>


